import React from "react";

import { faChevronLeft } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PageHeader, { type Props as PageHeaderProps } from "~/common/PageHeader";
import { Button } from "~/ui";

import styles from "./css/ItemPageHeader.module.css";

type Props = PageHeaderProps & {
	goBack?: () => void;
};

export default function ItemPageHeader({ goBack, ...props }: Props) {
	const backButton = (
		<Button size="wide" round className={styles.openPanelButton} onClick={goBack}>
			<FontAwesomeIcon icon={faChevronLeft} />
		</Button>
	);

	return <PageHeader {...props} backButton={goBack ? backButton : undefined} />;
}
